import type { PageGuide } from "../page-guide.js";

/** Help guide for Projects (centred workflow tour; no anchored panels yet). */
export const projectsGuide: PageGuide = {
  route: "/projects",
  version: 1,
  overviewArticleId: "projects-overview",
  steps: [
    {
      id: "create",
      title: "Create a project",
      body: 'Pick **Partner** first (e.g. gop), then create. **Share with … portal users** publishes a read-only plan to that partner\'s portal Project plan tab — not a generic "this tenant".',
    },
    {
      id: "plan",
      title: "Plan and track",
      body: "Open a project for its overview, **Kanban**, **Gantt**, stakeholders, and updates. Drag a task between columns to change its status.",
    },
    {
      id: "confidence",
      title: "Watch dependency health",
      body: "Review dependency confidence for missing, blocked, overdue, circular, or unscheduled hand-offs before they bite.",
    },
  ],
  panels: [],
  guidedActions: [],
};
